import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const deleteLanguage = (token, id) => {
    return fetch(`${apiUrl}languages/${id}`, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default deleteLanguage